module.exports = __webpack_public_path__ + "img/dashboard-truck-question.59e4f45e.svg";